import { IconProductCianLogo24 } from '@cian/ui-kit-design-tokens/icons';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../../selectors/page';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';
import { useApplicationContext } from '../../../utils/applicationContext';
import { trackNavigationItemClick } from '../tracking';

export const useMainPageNavigationItem = (): IMobileNavigationItem => {
  const {
    custom: { subdomain, mainPageUrl },
  } = useApplicationContext();

  const mainPageLink = mainPageUrl || /* istanbul ignore next */ `https://${subdomain}.cian.ru/`;

  const page = useSelector(selectPageType);

  const handleClick = useCallback(() => {
    trackNavigationItemClick('personalfeed');
  }, []);

  return {
    title: 'Главная',
    link: mainPageLink,
    icon: IconProductCianLogo24,
    isActive:
      page === 'main' ||
      page === 'mainCountryside' ||
      page === 'mainRent' ||
      page === 'mainRentDaily' ||
      page === 'mainSale',
    onClick: handleClick,
  };
};
